export const mapToControls = (controls) => {
	let controls_object = {};
	for (let i = 0; i < controls.length; i++) {
		controls_object[controls[i]['pageControlName']] = controls[i].pageControlRequired;
	}

	return controls_object;
};
